<template>
	<section>
		<painel-shell>
			<template v-slot:header-left>
				<navigation-header :title="$t('base.general.alerts')" :subtitle="$t('We care about your well-being.')"></navigation-header>
			</template>
			<header-simple :space-top="false" :title="$t('base.general.alerts')" :subtitle="$t('All alerts you have recive.')">
				<!-- <action-button :title="$t('buttons.actions.clear_alerts')" @click="onButtonClearAlerts" :remove-margin="true" /> -->
			</header-simple>
			<navigation-tab :tabs="tabs()" />
			<div class="alerts__container"><router-view/></div>
		</painel-shell>
	</section>
</template>

<script>
import NavigationTab from '@/components/navigation/NavigationTab'
import Grid from '@/modules/ui/Grid'
import GridItem from '@/modules/ui/GridItem'
import GridGroup from '@/modules/ui/GridGroup'
import HeaderSimple from '@/modules/ui/HeaderSimple'
import NavigationHeader from '@/components/navigation/NavigationHeader'
import PainelShell from '@/modules/shell/PainelShell'
import ActionButton from '@/modules/ui/ActionButton'
import ActionGroup from '@/modules/ui/ActionGroup'
import ActionGroupItemButton from '@/modules/ui/ActionGroupItemButton'
import { mapGetters } from 'vuex'

export default {
	components: {
		NavigationHeader,
		PainelShell,
		HeaderSimple,
		ActionGroup,
		ActionGroupItemButton,
		ActionButton,
		Grid,
		GridItem,
		GridGroup,
		NavigationTab
	},
	props: [
		'user_uid'
	],
	data () {
		return {
			tabs: () => [
				{ active: true, route: 'AlertList', title: `${this.$t('Unread')} (${this.getAlertsNewCount})` },
				{ active: true, route: 'AlertListAll', title: `${this.$t('Read')} (${this.getAlertsAllCount})` }
			]
		}
	},
	computed: {
		getAlertsNewCount() {
			return this.getAlertsNew(this.currentUser).length
		},
		getAlertsAllCount() {
			return this.getAlertsAll(this.currentUser).length
		},
		...mapGetters({
			getAlertsNew: 'WARNINGS_UNREAD',
			getAlertsAll: 'WARNINGS_READ',
			currentUser: 'CURRENT_USER',
			getPatient: 'PATIENT_BY_ID'
		})
	},
	methods: {
		onButtonClearAlerts() {

		},
		goToPatient(item) {
			this.$router.push({
				name: 'WatchDashboard',
				params: {
					user_uid: this.currentUser.uid,
					watch_id: item.virtual_watch_id
				}
			})
		}
	}
}
</script>

<style scoped>
.alerts__container {
	padding: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/user/UserAlerts.vue